var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDurationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04175 10.4998C1.04175 5.55228 5.05253 1.5415 10.0001 1.5415C14.9476 1.5415 18.9584 5.55228 18.9584 10.4998C18.9584 15.4474 14.9476 19.4582 10.0001 19.4582C5.05253 19.4582 1.04175 15.4474 1.04175 10.4998ZM10.0001 2.7915C5.74288 2.7915 2.29175 6.24264 2.29175 10.4998C2.29175 14.757 5.74288 18.2082 10.0001 18.2082C14.2573 18.2082 17.7084 14.757 17.7084 10.4998C17.7084 6.24264 14.2573 2.7915 10.0001 2.7915Z",
    fill: "#103C1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0035 4.875C10.3487 4.87503 10.6285 5.15488 10.6284 5.50006L10.628 10.2448L13.978 13.5948C14.222 13.8389 14.222 14.2346 13.978 14.4787C13.7339 14.7228 13.3381 14.7228 13.0941 14.4787L9.56099 10.9456C9.44376 10.8284 9.37791 10.6694 9.37793 10.5036L9.37843 5.49994C9.37846 5.15476 9.65831 4.87497 10.0035 4.875Z",
    fill: "#103C1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDurationIcon);
export default __webpack_public_path__ + "static/media/duration-icon.cc932f43e40706d95f71cfa2a76d9df3.svg";
export { ForwardRef as ReactComponent };